import { Button } from "@mui/material";
import React from "react";

export default function PrimaryButon({ text ,onClick }) {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      style={{
        background: "#572575",
        borderRadius: "8px",
        fontSize: "18px",
        fontFamily: "Inter",
        height: "39px",
      }}
      sx={{
        width: { xs: "100%", sm: "48%" },
      }}
    >
      {text}
    </Button>
  );
}
